import {Module, ActionTree, MutationTree, Store} from 'vuex';
import { RootState } from '@/store/types';
import { registerSubModule } from '@/utils/vueUtils';

import { ContestFormViewModel } from '@/modules/ContestFormModule/ContestFormModule.types';
import { ContestEntry } from '@/modules/ContestFormModule/ContestForm/ContestForm.types';

import { InitCountries } from '@/api/CountryStateApi';

import {
  submitContest,
} from '@/modules/ContestFormModule/ContestFormModule.api';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

export interface ContestFormModuleState {
  IsSubmitted: boolean;
}

export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_FORM_IS_SUBMITTED = 'SET_FORM_IS_SUBMITTED';

const actions: ActionTree<ContestFormModuleState, RootState> = {
  async [SUBMIT_FORM]({ commit }, model: ContestEntry) {
    //console.log('submitted', model);
    const result = await submitContest(model);
    if (result.IsOk) {
      //console.log('from server', result);
      commit(SET_FORM_IS_SUBMITTED);
    } else {
      //console.log('error', result);
    }
  },
};

const mutations: MutationTree<ContestFormModuleState> = {
  [SET_FORM_IS_SUBMITTED](state) {
    state.IsSubmitted = true;
    Vue.nextTick(() => {
      VueScrollTo.scrollTo('#ContestForm');
    });
  },
};

const registerModule = registerSubModule<ContestFormModuleState, ContestFormViewModel>(
  (data: ContestFormViewModel) => {
    return {
      namespaced: true,
      state: {
        IsSubmitted: false,
      },
      actions,
      mutations,
    } as Module<ContestFormModuleState, RootState>;
  },
  'ContestFormModule',
);

export default async (store: Store<RootState>, data: ContestFormViewModel) => {
  await InitCountries();

  return registerModule(store, data)
}
